import { render, staticRenderFns } from "./UcBody.yaml?vue&type=template&id=6d6b1aa5&component"
import script from "./UcBody.yaml?vue&type=script&lang=ts&component"
export * from "./UcBody.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports